<template>
  <article
    :class="$style.container"
    data-test-id="LegacySettings__Container"
  >
    <header
      v-if="hasBanner"
      :class="$style.banner"
    >
      <slot name="banner" />
    </header>
    <section :class="$style.settingsContent">
      <slot />
    </section>
    <footer :class="$style.footer">
      <ul>
        <li>
          <button
            :class="$style.cancelButton"
            @click="handleCancel"
          >
            cancel
          </button>
        </li>
        <li>
          <FlatActionButton
            :action="handleSave"
            buttonClass="btnDefault btnCTA"
            :disabled="!enableMainAction"
            :loading="loading"
          >
            save changes
          </FlatActionButton>
        </li>
      </ul>
    </footer>
  </article>
</template>

<script>
/**
 * Deprecated: This component is being phased out. Please do not use it in any new work.
 */
import FlatActionButton from 'components/Buttons/FlatActionButton.vue';

export default {
  name: 'LegacySettingsContainer',

  inject: ['$validator'],

  components: {
    FlatActionButton,
  },

  props: {
    enableMainAction: Boolean,
    loading: Boolean,
  },

  computed: {
    hasBanner() {
      return !!this.$slots.banner;
    },
  },

  methods: {
    handleCancel() {
      this.$emit('cancel');
    },

    handleSave() {
      this.$emit('save');
    },
  },
};
</script>

<style module>
@import '../../css/LegacySecuritySettings.css';

@value (jcGrey900) from '~css/brand-colors.css';

.container.container {
  display: grid;
  font-size: 1rem;
  grid-gap: 20px;
  grid-template:
    'settings-banner' auto
    'settings-content' 1fr
    'settings-footer' auto / 1fr;
  height: 100%;
  min-height: 0;
}

.banner {
  grid-area: settings-banner;
}

.settingsContent {
  grid-area: settings-content;
  overflow: auto;
  padding: 0 20px;
  scroll-behavior: smooth;
}

.footer {
  grid-area: settings-footer;
  padding: 0 15px;
  text-align: right;
}

.footer ul {
  list-style-type: none;
}

.footer li {
  display: inline-block;
  margin-left: 15px;
}

.cancelButton {
  background: none;
  color: jcGrey900;
  font-size: 12px;
  padding: 0;
  text-decoration: underline;
}

.cancelButton:hover {
  cursor: pointer;
}
</style>
